import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCharactersGradeTbclPageQueryOptions } from "#use-characters-grade-tbcl-page-query-options";
import { useCallback } from "react";

/** Characters → TBCL view: every TBCL level concatenated into one scrollable, sectioned by band. */
function useNavigator() {
  const charactersGradeTbclPageQueryOptions = useCharactersGradeTbclPageQueryOptions();

  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/browse/(browse-tabs)/characters/grade/tbcl",
      },
      queries: [charactersGradeTbclPageQueryOptions],
    }),
    [charactersGradeTbclPageQueryOptions],
  );
}

export const useBrowseCharactersTbclPageNavigator = createPageNavigator<void>({
  useNavigator,
});
